import React from "react";
import { FileText } from "lucide-react";
import AppLayout from "../components/AppLayout";
import StorageFileLink from "../components/StorageFileLink";
import { useAuth } from "../contexts/AuthContext";
import { useToast } from "../contexts/ToastContext";
import {
  EmptyState,
  SectionCard,
  useTenantPortalData,
} from "./tenantPortalShared.jsx";

export default function TenantDocumentsPage({ isDark, setIsDark, currency, setCurrency }) {
  const { user } = useAuth();
  const toast = useToast();
  const { documents } = useTenantPortalData(user, toast);

  return (
    <AppLayout
      isDark={isDark}
      setIsDark={setIsDark}
      currency={currency}
      setCurrency={setCurrency}
      eyebrow="Resident Portal"
      title="My documents"
      description="Supporting tenancy files linked to your resident record."
    >
      <SectionCard
        title="Document library"
        description="Lease files and resident documents shared with your account."
        isDark={isDark}
      >
        {documents.length === 0 ? (
          <EmptyState
            title="No documents linked"
            body="Lease files and resident documents will appear here when they are attached to your tenant record."
            isDark={isDark}
          />
        ) : (
          <div className="space-y-3">
            {documents.map((document) => (
              <StorageFileLink
                key={`${document.label}-${document.reference}`}
                reference={document.reference}
                target="_blank"
                rel="noreferrer"
                className={`flex items-center justify-between rounded-2xl border p-4 transition ${
                  isDark
                    ? "border-slate-800 bg-slate-950 text-white hover:bg-slate-800"
                    : "border-slate-200 bg-slate-50 text-slate-900 hover:bg-white"
                }`}
              >
                <div className="min-w-0">
                  <p className="truncate text-sm font-semibold">{document.label}</p>
                  <p className={`mt-1 truncate text-xs ${isDark ? "text-slate-400" : "text-slate-500"}`}>{document.reference}</p>
                </div>
                <FileText className={`ml-4 h-5 w-5 shrink-0 ${isDark ? "text-slate-400" : "text-slate-500"}`} />
              </StorageFileLink>
            ))}
          </div>
        )}
      </SectionCard>
    </AppLayout>
  );
}
